import { render, staticRenderFns } from "./homeDashboardWorkCalendarStatistics.vue?vue&type=template&id=fa0986da&scoped=true"
import script from "./homeDashboardWorkCalendarStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardWorkCalendarStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardWorkCalendarStatistics.vue?vue&type=style&index=0&id=fa0986da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0986da",
  null
  
)

export default component.exports